export default "__VITE_ASSET__D$2d6tS9__"